import React, { useState } from "react";
import axios from "../../../axios";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  Fade,
  Zoom,
  Backdrop,
  Stack,
  Avatar,
  CircularProgress,
} from "@mui/material";
import {
  WarningAmber,
  DeleteForever,
  Close,
  EventNote,
  AccessTime,
} from "@mui/icons-material";
import SucessDeleted from "./SucessDeleted";

const DeleteUpdate = ({
  setDelClick,
  delSeriesLecture,
  delThisLecture,
  delDetails,
  onSuccess,
}) => {
  let timetableId = localStorage.getItem("TimetableId");
  const [isInProgress, setIsInProgress] = useState(false);
  const [sucess, setSucess] = useState(false);

  function convertTo12HourFormat(time) {
    let hours = Math.floor(time / 100);
    let minutes = time % 100;

    let period = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;

    minutes = minutes < 10 ? "0" + minutes : minutes;

    return `${hours}:${minutes} ${period}`;
  }

  const handleDelete = async () => {
    try {
      setIsInProgress(true);
      const recurrence = delSeriesLecture ? "true" : "false";
      let res = await axios.delete(
        `/api/v1/timetable/lecture/delete/timetableId/${timetableId}/lectureId/${delDetails?.data?.id}?recurrence=${recurrence}`,
      );
      if (res.status === 200) {
        setIsInProgress(false);
        setSucess(true);
      }
    } catch (error) {
      setIsInProgress(false);
      console.log(error);
    }
  };

  if (sucess) return <SucessDeleted onSuccess={onSuccess} />;

  return (
    <Dialog
      open={true}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          overflow: "visible",
          bgcolor: "transparent",
          boxShadow: "none",
        },
      }}
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(8px)",
          },
        },
      }}
    >
      <Fade in={true} timeout={400}>
        <Box>
          <Zoom in={true} timeout={500}>
            <Box
              sx={{
                position: "relative",
                bgcolor: "#ffffff",
                borderRadius: 4,
                boxShadow: "0 24px 64px rgba(0,0,0,0.18)",
                overflow: "hidden",
              }}
            >
              {/* Top red gradient bar */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: 5,
                  background:
                    "linear-gradient(90deg, #d32f2f, #ef5350, #d32f2f)",
                  backgroundSize: "200% 100%",
                  animation: "shimmer 2s infinite linear",
                  "@keyframes shimmer": {
                    "0%": { backgroundPosition: "200% 0" },
                    "100%": { backgroundPosition: "-200% 0" },
                  },
                }}
              />

              {/* Close button top right */}
              <Box sx={{ position: "absolute", top: 12, right: 12, zIndex: 1 }}>
                <Button
                  onClick={() => setDelClick(false)}
                  sx={{
                    minWidth: 32,
                    width: 32,
                    height: 32,
                    borderRadius: "50%",
                    p: 0,
                    color: "text.secondary",
                    "&:hover": { bgcolor: "#f5f5f5", color: "#d32f2f" },
                  }}
                >
                  <Close fontSize="small" />
                </Button>
              </Box>

              <DialogContent sx={{ p: 4, pt: 5, textAlign: "center" }}>
                {isInProgress ? (
                  <Stack spacing={3} alignItems="center" sx={{ py: 4 }}>
                    <CircularProgress
                      size={60}
                      thickness={4}
                      sx={{ color: "#f77f00" }}
                    />
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      color="text.secondary"
                    >
                      Deleting lecture...
                    </Typography>
                  </Stack>
                ) : (
                  <Stack spacing={3} alignItems="center">
                    {/* Warning Icon */}
                    <Box
                      sx={{
                        position: "relative",
                        "&::before": {
                          content: '""',
                          position: "absolute",
                          top: -8,
                          left: -8,
                          right: -8,
                          bottom: -8,
                          borderRadius: "50%",
                          border: "3px solid #ffebee",
                          animation:
                            "pulse-ring 1.5s cubic-bezier(0.215, 0.61, 0.355, 1) infinite",
                          "@keyframes pulse-ring": {
                            "0%": { transform: "scale(0.8)", opacity: 1 },
                            "100%": { transform: "scale(1.3)", opacity: 0 },
                          },
                        },
                      }}
                    >
                      <Avatar
                        sx={{
                          width: 90,
                          height: 90,
                          bgcolor: "#ffebee",
                          boxShadow: "0 8px 24px rgba(211,47,47,0.2)",
                        }}
                      >
                        <WarningAmber
                          sx={{
                            fontSize: 50,
                            color: "#d32f2f",
                            animation:
                              "popIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                            "@keyframes popIn": {
                              "0%": { transform: "scale(0)", opacity: 0 },
                              "100%": { transform: "scale(1)", opacity: 1 },
                            },
                          }}
                        />
                      </Avatar>
                    </Box>

                    {/* Title */}
                    <Typography variant="h5" fontWeight={800} color="#2d3436">
                      Are you sure?
                    </Typography>

                    {/* Lecture Info Card */}
                    {delDetails?.data && (
                      <Box
                        sx={{
                          width: "100%",
                          p: 2,
                          borderRadius: 2,
                          bgcolor: "#fafafa",
                          border: "1px solid #eeeeee",
                          textAlign: "left",
                        }}
                      >
                        <Stack spacing={1}>
                          <Typography
                            variant="subtitle2"
                            fontWeight={700}
                            color="text.primary"
                          >
                            {delDetails.data.name || "Untitled Lecture"}
                          </Typography>
                          <Stack direction="row" spacing={2}>
                            {delDetails.data.classType && (
                              <Typography
                                variant="caption"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                  color: "text.secondary",
                                }}
                              >
                                <EventNote fontSize="small" />
                                {delDetails.data.classType === "special"
                                  ? "Special Lecture"
                                  : delDetails.data.classType === "general"
                                    ? "General Lecture"
                                    : "Lecture"}
                              </Typography>
                            )}
                            {delDetails.data.start_time &&
                              delDetails.data.end_time && (
                                <Typography
                                  variant="caption"
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    color: "text.secondary",
                                  }}
                                >
                                  <AccessTime fontSize="small" />
                                  {convertTo12HourFormat(
                                    delDetails.data.start_time,
                                  )}{" "}
                                  -{" "}
                                  {convertTo12HourFormat(
                                    delDetails.data.end_time,
                                  )}
                                </Typography>
                              )}
                          </Stack>
                        </Stack>
                      </Box>
                    )}

                    {/* Warning Message */}
                    <Box sx={{ maxWidth: 320 }}>
                      <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ lineHeight: 1.7 }}
                      >
                        You are about to{" "}
                        <Box
                          component="span"
                          sx={{ fontWeight: 700, color: "#d32f2f" }}
                        >
                          {delSeriesLecture
                            ? "delete this lecture series"
                            : "delete this lecture"}
                        </Box>
                        .
                      </Typography>
                      <Box
                        sx={{
                          mt: 1.5,
                          p: 1.5,
                          borderRadius: 2,
                          bgcolor: "#ffebee",
                          border: "1px dashed #ef9a9a",
                        }}
                      >
                        <Typography
                          variant="body2"
                          color="#c62828"
                          fontWeight={600}
                        >
                          ⚠️ Associated supplements will be de-linked.
                        </Typography>
                      </Box>
                    </Box>

                    {/* Action Buttons */}
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{ width: "100%", mt: 1 }}
                    >
                      <Button
                        fullWidth
                        variant="outlined"
                        size="large"
                        onClick={() => setDelClick(false)}
                        sx={{
                          borderRadius: 3,
                          py: 1.2,
                          fontWeight: 700,
                          textTransform: "none",
                          borderColor: "#e0e0e0",
                          color: "#616161",
                          "&:hover": {
                            borderColor: "#bdbdbd",
                            bgcolor: "#f5f5f5",
                          },
                        }}
                      >
                        No, Cancel
                      </Button>
                      <Button
                        fullWidth
                        variant="contained"
                        size="large"
                        onClick={handleDelete}
                        startIcon={<DeleteForever />}
                        sx={{
                          borderRadius: 3,
                          py: 1.2,
                          fontWeight: 700,
                          textTransform: "none",
                          background:
                            "linear-gradient(135deg, #d32f2f 0%, #ef5350 100%)",
                          boxShadow: "0 8px 24px rgba(211,47,47,0.3)",
                          "&:hover": {
                            background:
                              "linear-gradient(135deg, #b71c1c 0%, #d32f2f 100%)",
                            boxShadow: "0 12px 32px rgba(211,47,47,0.4)",
                            transform: "translateY(-1px)",
                          },
                          transition: "all 0.3s ease",
                        }}
                      >
                        Yes, Delete
                      </Button>
                    </Stack>
                  </Stack>
                )}
              </DialogContent>
            </Box>
          </Zoom>
        </Box>
      </Fade>
    </Dialog>
  );
};

export default DeleteUpdate;
